<template>
    <div
        :class="{ block: open, hidden: !open }"
        class="border-b border-gray-700 md:hidden"
    >
        <nav-links
            class="px-2 py-3 sm:px-3"
            defaultClass="block px-3 py-2 mt-1 text-base font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
        >
        </nav-links>
        <div class="pt-4 pb-3 border-t border-gray-700">
            <div class="flex items-center px-5">
                <div class="flex-shrink-0">
                    <img
                        class="w-12 h-12 rounded-full"
                        :src="`/img/${user.username}.jpg`"
                        alt=""
                    />
                </div>
                <div class="ml-3">
                    <div class="text-base font-medium leading-none text-white">
                        {{ user.name }}
                    </div>
                    <div class="mt-1 text-sm font-medium leading-none text-gray-400">
                        {{ user.email }}
                    </div>
                </div>
            </div>
            <div
                class="px-2 mt-3"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
            >
                <a
                    href="#"
                    class="block px-3 py-2 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                    role="menuitem"
                >
                    Profilo
                </a>
                <a
                    href="#"
                    class="block px-3 py-2 mt-1 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                    role="menuitem"
                >
                    Impostazioni
                </a>
                <span
                    @click="$emit('logout')"
                    class="block px-3 py-2 mt-1 text-base font-medium text-gray-400 rounded-md cursor-pointer hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                    role="menuitem"
                >
                    Logout
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import NavLinks from "./NavLinks";
export default {
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NavLinks
    },
    computed: {
        ...mapState("app", ["user"])
    },
    methods: {
        ...mapGetters("app", ["group"])
    }
};
</script>
